import React from 'react';

class SubmitMessage extends React.Component {
	render() {

		let message = '';

		if (this.props.sent && this.props.show) {
			message = 'Thanks. Your message has been sent successfully.';
		} else if (this.props.show) {
			message = 'There was a problem sending your message. Please check the fields and try again.';
		}

		return (
			<div className="validation-submit-success">
				<span key={this.props.show}>{message}</span>
			</div>			
		)
	}
}


SubmitMessage.propTypes = {  

};

export default SubmitMessage;


// WEBPACK FOOTER //
// ./src/components/formComponents/SubmitMessage.js